import { memo, useMemo } from 'react';

import {
    accountCurrencyKey,
    bankCountryCodeKey,
    entityTypeKey,
    fieldAppearanceAddress,
    fieldAppearanceBankDetails,
    localClearingSystemKey,
    paymentMethodKey,
} from '../../AddBeneficiaryPopup.constants';
import { Field } from '../../AddBeneficiaryPopup.types';
import Fields from '../Fields/Fields';
import { messages } from './StepThree.messages';
import { SectionHeader } from './StepThree.styles';
import { StepThreeProps } from './StepThree.types';

const fieldKeysFromPreviousSteps = [
    entityTypeKey,
    bankCountryCodeKey,
    accountCurrencyKey,
    paymentMethodKey,
    localClearingSystemKey,
];

const StepThree = memo<StepThreeProps>((props) => {
    const {
        fields = [],
        formValues,
        setFormValues,
        validationErrors,
        setValidationErrors,
        fieldsTouched,
        setFieldsTouched,
    } = props;

    const filteredFields = useMemo(
        () => fields.filter((item) => !fieldKeysFromPreviousSteps.includes(item.path)),
        [fields]
    );

    const fieldsBankDetails = useMemo(
        () =>
            fieldAppearanceBankDetails.reduce<Field[]>((acc, appearanceField) => {
                const field = filteredFields.find((filteredField) => filteredField.path === appearanceField.path);

                if (field) {
                    acc.push(field);
                }

                return acc;
            }, []),
        [filteredFields]
    );

    const fieldsAddress = useMemo(
        () =>
            fieldAppearanceAddress.reduce<Field[]>((acc, appearanceField) => {
                const field = filteredFields.find((filteredField) => filteredField.path === appearanceField.path);

                if (field) {
                    acc.push(field);
                }

                return acc;
            }, []),
        [filteredFields]
    );

    const fieldsMisc = useMemo(
        () =>
            filteredFields.filter((field) => {
                return (
                    !fieldAppearanceAddress.find(
                        (fieldAppearanceAddressItem) => fieldAppearanceAddressItem.path === field.path
                    ) && !fieldsBankDetails.find((fieldsBankDetailsItem) => fieldsBankDetailsItem.path === field.path)
                );
            }),
        [fieldsBankDetails, filteredFields]
    );

    return (
        <>
            <SectionHeader>{messages.bankDetails}</SectionHeader>

            <Fields
                fields={fieldsBankDetails}
                formValues={formValues}
                setFormValues={setFormValues}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                fieldsTouched={fieldsTouched}
                setFieldsTouched={setFieldsTouched}
            />

            <SectionHeader>{messages.address}</SectionHeader>

            <Fields
                fields={fieldsAddress}
                formValues={formValues}
                setFormValues={setFormValues}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                fieldsTouched={fieldsTouched}
                setFieldsTouched={setFieldsTouched}
            />

            {fieldsMisc.length > 0 && (
                <>
                    <SectionHeader>{messages.misc}</SectionHeader>

                    <Fields
                        fields={fieldsMisc}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                        fieldsTouched={fieldsTouched}
                        setFieldsTouched={setFieldsTouched}
                    />
                </>
            )}
        </>
    );
});

export default StepThree;
